import { jsx as r, jsxs as i } from "react/jsx-runtime";
import { twMerge as e } from "tailwind-merge";
const d = ({
  description: n,
  descriptionClassName: s,
  error: t,
  errorClassName: a,
  className: l
}) => {
  const m = !t || Array.isArray(t) && !t.length ? null : /* @__PURE__ */ r(
    "p",
    {
      className: e("text-danger [&>a]:text-brand-primary text-sm", a),
      ...typeof t == "string" ? {
        dangerouslySetInnerHTML: { __html: t }
      } : {
        children: t
      }
    }
  );
  return t || n ? /* @__PURE__ */ i("div", { className: l, children: [
    n ? /* @__PURE__ */ r(
      "span",
      {
        className: e("[&>a]:text-brand-primary text-sm opacity-70", s),
        children: n
      }
    ) : null,
    m
  ] }) : null;
};
export {
  d as FieldErrorAndDescription
};
